import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\BannerController::upload
* @see app/Http/Controllers/BannerController.php:129
* @route '/admin/marketing/banners/{banner}/media'
*/
export const upload = (args: { banner: string | number | { id: string | number } } | [banner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: upload.url(args, options),
    method: 'post',
})

upload.definition = {
    methods: ["post"],
    url: '/admin/marketing/banners/{banner}/media',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\BannerController::upload
* @see app/Http/Controllers/BannerController.php:129
* @route '/admin/marketing/banners/{banner}/media'
*/
upload.url = (args: { banner: string | number | { id: string | number } } | [banner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { banner: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { banner: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            banner: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        banner: typeof args.banner === 'object'
        ? args.banner.id
        : args.banner,
    }

    return upload.definition.url
            .replace('{banner}', parsedArgs.banner.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\BannerController::upload
* @see app/Http/Controllers/BannerController.php:129
* @route '/admin/marketing/banners/{banner}/media'
*/
upload.post = (args: { banner: string | number | { id: string | number } } | [banner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: upload.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BannerController::upload
* @see app/Http/Controllers/BannerController.php:129
* @route '/admin/marketing/banners/{banner}/media'
*/
const uploadForm = (args: { banner: string | number | { id: string | number } } | [banner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: upload.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BannerController::upload
* @see app/Http/Controllers/BannerController.php:129
* @route '/admin/marketing/banners/{banner}/media'
*/
uploadForm.post = (args: { banner: string | number | { id: string | number } } | [banner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: upload.url(args, options),
    method: 'post',
})

upload.form = uploadForm

/**
* @see \App\Http\Controllers\BannerController::deleteMethod
* @see app/Http/Controllers/BannerController.php:179
* @route '/admin/marketing/banners/{banner}/media/{mediaId}'
*/
export const deleteMethod = (args: { banner: string | number | { id: string | number }, mediaId: string | number } | [banner: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/admin/marketing/banners/{banner}/media/{mediaId}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\BannerController::deleteMethod
* @see app/Http/Controllers/BannerController.php:179
* @route '/admin/marketing/banners/{banner}/media/{mediaId}'
*/
deleteMethod.url = (args: { banner: string | number | { id: string | number }, mediaId: string | number } | [banner: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            banner: args[0],
            mediaId: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        banner: typeof args.banner === 'object'
        ? args.banner.id
        : args.banner,
        mediaId: args.mediaId,
    }

    return deleteMethod.definition.url
            .replace('{banner}', parsedArgs.banner.toString())
            .replace('{mediaId}', parsedArgs.mediaId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\BannerController::deleteMethod
* @see app/Http/Controllers/BannerController.php:179
* @route '/admin/marketing/banners/{banner}/media/{mediaId}'
*/
deleteMethod.delete = (args: { banner: string | number | { id: string | number }, mediaId: string | number } | [banner: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\BannerController::deleteMethod
* @see app/Http/Controllers/BannerController.php:179
* @route '/admin/marketing/banners/{banner}/media/{mediaId}'
*/
const deleteMethodForm = (args: { banner: string | number | { id: string | number }, mediaId: string | number } | [banner: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteMethod.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BannerController::deleteMethod
* @see app/Http/Controllers/BannerController.php:179
* @route '/admin/marketing/banners/{banner}/media/{mediaId}'
*/
deleteMethodForm.delete = (args: { banner: string | number | { id: string | number }, mediaId: string | number } | [banner: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteMethod.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

deleteMethod.form = deleteMethodForm

const media = {
    upload: Object.assign(upload, upload),
    delete: Object.assign(deleteMethod, deleteMethod),
}

export default media